import ProductBoxContainer from './ProductBoxContainer';

export default ProductBoxContainer;
